/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceStepResource } from './';
import {
    ComplianceStepResourceFromJSON,
    ComplianceStepResourceFromJSONTyped,
    ComplianceStepResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComplianceContextResource
 */
export interface ComplianceContextResource {
    /**
     * The freelancer's account ID
     * @type {string}
     * @memberof ComplianceContextResource
     */
    accountId?: string;
    /**
     * 
     * @type {Array<ComplianceStepResource>}
     * @memberof ComplianceContextResource
     */
    menu?: Array<ComplianceStepResource>;
}

/**
 * Check if a given object implements the ComplianceContextResource interface.
 */
export function instanceOfComplianceContextResource(value: object): value is ComplianceContextResource {
    return true;
}

export function ComplianceContextResourceFromJSON(json: any): ComplianceContextResource {
    return ComplianceContextResourceFromJSONTyped(json, false);
}

export function ComplianceContextResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceContextResource {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'menu': json['menu'] == null ? undefined : ((json['menu'] as Array<any>).map(ComplianceStepResourceFromJSON)),
    };
}

export function ComplianceContextResourceToJSON(value?: ComplianceContextResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'menu': value['menu'] == null ? undefined : ((value['menu'] as Array<any>).map((v) => ComplianceStepResourceToJSON(v))),
    };
}

